import styled, {css} from 'styled-components';

import {PageContent} from '../../styles/pages/pages';
import {LoadingContainer} from '../../styles/components/layout';
import {MESSAGE_LEVEL} from '../../constants/constants';

export const DropInContent = styled(PageContent)`
  padding: 1rem 2rem 2rem;
  min-height: 60rem;
`;

export const LoadingWrapper = styled(LoadingContainer)`
  margin-top: 16rem;
`;

export const UpdateButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 1rem;
`;

export const Info = styled.div`
  padding: 1rem 0 2rem;
  font-size: 1.4rem;
  color: ${p => p.theme.textColor};
`;

export const MessagesContainer = styled.div`
  margin-bottom: 2rem;
`;

export const MessageItem = styled.div`
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  border-radius: 0.4rem;
  font-size: 1.4rem;
  font-weight: 500;
  border: 1px solid ${p => p.theme.borderColor};

  ${p =>
    p.$level === MESSAGE_LEVEL.WARNING &&
    css`
      background-color: ${p.theme.warningBgColor};
      border-color: ${p.theme.warningBorderColor};
      color: ${p.theme.warningTextColor};
    `}

  ${p =>
    p.$level === MESSAGE_LEVEL.ERROR &&
    css`
      background-color: ${p.theme.errorBgColor};
      border-color: ${p.theme.tertiaryColor};
      color: ${p.theme.tertiaryColor};
    `}

  ${p =>
    p.$level === MESSAGE_LEVEL.INFO &&
    css`
      background-color: ${p.theme.secondaryLightHover};
      border-color: ${p.theme.primaryColor};
      color: ${p.theme.primaryColor};
    `}
`;
